// @ts-nocheck
import React from 'react';

const SportPage2 = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[400px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Спорт </h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Спортивний клуб «Дон Боско» був заснований у 2006 році і є покликаний надати дітям можливість розвивати їх дух і тіло в позашкільний час. Футбольний Клуб «Покрова», який входить до структури СК «Дон Боско» налічує понад 400 дітей різних вікових груп.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              Основним завданням є виховання дітей у вірі в Ісуса Христа через катехитичні зустрічі та молитву. Також важливим є навчання дітей жити християнським життя через Святі Тайни, особливо Тайну Покаяння та Євхаристії. Запропонувати їм як зразок прикладних осіб, які вірно живуть згідно християнським цінностям. Футбольний клуб притримується думки, що у здоровому тілі здоровий дух.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[400px] object-cover object-right rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/sportpage.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-col items-center md:pl-16 md:flex-row">

          <div className="relative md:w-1/2">
            <div>
              <div className="w-full pt-6 text-md hyphens-auto md:hyphens-manual md:pr-10">
                Метою клубу є допомога кожному у реалізації життєвої мрії, відкриття багатства особистості через футбол,  супровід, підтримка, формування командного духу, через поразки та здобутки.
              </div>
                        </div>
            <div class="hidden md:block absolute top-1/2 right-0 -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[40px] border-b-[40px] border-r-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
          <div className="max-md:mt-4 relative max-md:ml-[28px] md:w-2/3 bg-[#A81414] md:h-[80px] flex justify-center items-center px-8 rounded-tr-xl rounded-br-xl">
            <div class="md:hidden absolute top-1/2 -left-[12px] -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[26px] border-b-[26px] border-r-[12px]
              md:border-t-[42px] md:border-b-[42px] md:border-r-[22px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <h3 className="text-[14px] md:text-[30px] items-center flex  justify text-white uppercase text- nt-bold hyphens-auto max-md:leading-4 max-md:py-[10px]">
              Слоган клубу: Мріяти, вірити, досягти!
            </h3>
          </div>
        </div>
        <div className="py-6 text-justify md:px-16 hyphens-auto">
          Футбольний Клуб «Покрова» — це місце добрих стосунків з Богом, з ближніми, а також можливість отримати добру професійну підготовку футболіста. Клуб втілює засади справжнього, відданого ідеалу футболу.
        </div>
        <div className="pt-3 text-justify md:px-16 hyphens-auto">
          З 2006 року команди беруть участь у ДЮФЛУ першої ліги та вищої ліги України.
        </div>
        <div className="pb-6 text-justify md:px-16 hyphens-auto">
          З 2022 року була створена команда U-19 для юнаків, яка допомагає продовжити ігрову практику та віднайти себе у футболі.
        </div>

        <div className="flex">
          <div className="relative w-[90%] md:w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-[24px] md:pl-8 rounded-tl-xl rounded-bl-xl">
            <h3 className="text-2xl text-justify text-white uppercase md:text-4xl nt-bold hyphens-auto">База клубу:</h3>
          </div>
          <div className="relative md:w-3/5">
            <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="">
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="pt-3">
                  Президент клубу: отець Анатолій Гецянин, СДБ.
                </div>
                <div className="">
                  Спортивний директор: Олег Бойчишин.
                </div>
                <div className="pt-3">
                  Вул. Дорога Кривчицька, 19

                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:flex border-[2px] border-[#A81414]">
          </div>
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              Запис до клубу можна зробити за номером телефону, або у соціальних мережах:
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="pt-3 underline">
                  <a href="https://www.facebook.com/profile.php?id=100079752860064&locale=uk_UA">Facebook</a>
                </div>
                <div className="underline ">
                  <a href="https://www.instagram.com/fc_pokrova_official/">Instagram</a>
                </div>
                <div className="">
                  +380676964170
                </div>
              </div>
            </div>
          </div>

        </div>
        <h3 className="max-md:pb-3 py-6 text-xl md:text-4xl font-bold text-justify uppercase hyphens-auto text-[#A81414]">“Покрова АМП”</h3>
        <div className="md:px-16">
          <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
            <li>
              У 2023 році була заснована команда “Покрова АМП”, до складу якої входять гравці з ампутованою однією верхньою або нижньою кінцівкою, 80% з них — ветерани. У 2024 і 2025 роках команда взяла участь у двох Чемпіонатах Польщі — PZU Amp Futbol Ekstraklasa, а у 2025 році також у Чемпіонаті України з ампфутболу. “Покрова АМП” стала переможцем зимового та весняного кубків Ліги Дужих. Десять гравців команди увійшли до складу національної збірної України з ампфутболу.
            </li>
          </ul>
        </div>
        <div className="flex mt-6">
          <div className="relative w-[90%] md:w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-[24px] md:pl-8 rounded-tl-xl rounded-bl-xl">
            <h3 className="text-2xl text-justify text-white uppercase md:text-4xl nt-bold hyphens-auto">База клубу:</h3>
          </div>
          <div className="relative md:w-3/5">
            <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="">
            <div className="flex my-2 max-md:ml-4">
              <div className="hidden md:flex border-[2px] border-[#A81414]  mr-6">
              </div>
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="pt-3">
                  Почесний Президент ампфутболу: отець Михайло Чабан.
                </div>
                <div className="">
                  Президент ампфутболу: Богдан Мельник.

                </div>
                <div className="pt-3">
                  Вул. Дорога Кривчицька, 19

                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SportPage2;
